import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ROLE_DASHBOARD = {
  admin:      '/admin/dashboard',
  instructor: '/instructor/dashboard',
  student:    '/student/dashboard',
};

// requiredRole: 'admin' | 'instructor' | 'student'
export default function ProtectedRoute({ children, requiredRole }) {
  const { user, ready } = useAuth();

  // Wait until session check completes before making any decision
  if (!ready) return null;

  // Not logged in → back to login
  if (!user) return <Navigate to="/" replace />;

  // Logged in but wrong role → redirect to their own dashboard
  if (user.role.slug !== requiredRole) {
    return <Navigate to={ROLE_DASHBOARD[user.role.slug] || '/'} replace />;
  }

  return children;
}
